import Vue from 'vue'
import App from './App'
import router from './routes'
import store from './store'
import moment from 'moment';
import EventBus from './plugins/event-bus';
import UserInfoTool from '@/plugins/user-info-tool';
import './api';
import './plugins/antd';
import './plugins/axios'
import './plugins/components';

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import utils from '@/utils';
import { btnAuth } from '@/mixins/auth-btn.mixin';
import { commonFilters } from '@/mixins/common-filters.mixin';
import commonOptions from '@/utils/common-options-map';
Vue.prototype.$utils = utils;

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$moment = moment;
Vue.prototype.$userInfoTool = UserInfoTool;
Vue.prototype.$commonOptions = commonOptions;
Vue.config.productionTip = false


Vue.mixin(btnAuth);
Vue.mixin(commonFilters);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')